const API_URL = import.meta.env.VITE_GETSIGN_API_URL;
const API_URL_V2 = import.meta.env.VITE_GETSIGN_API_URL_V2;

export const getToken = async (payload) => {
  const res = await fetch(`${API_URL}/authorize`, {
    body: JSON.stringify(payload),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.json();
};

export const getMondayToken = async () => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');

    const res = await fetch(`${API_URL_V2}/token`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
    });
    if (res.status === 401) {
      return res;
    }
    return res.json();
  } catch (error) {}
};
